import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom'
import TabsMui from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { usePatientContext } from '@/v2/contexts/PatientContext'
import { usePatientProfile } from '@/v2/hooks/patient/usePatient'
import Alert from '../Alert'

const Tabs = styled(TabsMui)`
  margin-right: 25px;
  display: inline-flex;

  @media (max-width: 1366px) {
    margin-right: 12px;

    .MuiTab-root {
      min-width: auto;
      padding: 12px 8px;
      font-size: 13px;
    }
  }
`

const NavigationTabs = () => {
  const { id, view } = useParams()
  const navigate = useNavigate()
  const [tab, setTab] = useState(view || 'profile')
  const [showAlert, setShowAlert] = useState(false)
  const { patient } = usePatientProfile(id)
  const { medicalAlerts, officeNotes } = usePatientContext()
  const overdueAlert = patient?.hasOverdueInvoice
    ? [
        {
          name: 'overdueInvoice',
          label: 'Patient has an overdue payment',
          color: 'red',
        },
      ]
    : []

  const patientAlerts = [
    ...officeNotes.filter(({ alerts }) => alerts),
    ...medicalAlerts,
    ...overdueAlert,
  ]

  useEffect(() => {
    setShowAlert(patientAlerts.length > 0)
  }, [patientAlerts.length])

  // Sync tab state with URL param
  useEffect(() => {
    if (view) {
      setTab(view)
    }
  }, [view])

  const handleChange = (e, newTab) => {
    setTab(newTab)
    navigate(`/v2/patient/${id}/${newTab}`)
  }

  return (
    <>
      {showAlert && (
        <Alert alerts={patientAlerts} onClose={() => setShowAlert(false)} />
      )}

      <Tabs
        value={tab}
        className="patient-navigation"
        onChange={handleChange}
        aria-label="nav tabs"
      >
        <Tab value="profile" label="Profile" />
        <Tab value="treatment" label="Treatment" />
        <Tab value="insurance" label="Insurance" />
        <Tab value="documents" label="Documents" />
        <Tab value="imaging" label="Imaging" />
        <Tab value="finance" label="Finance" />
      </Tabs>
    </>
  )
}

export default NavigationTabs
